import React, { useEffect, useState } from "react";
import AwsServerService from "../../common/util/AwsServerService";
import "./MilestoneNew.css";
import { log } from "mathjs";
import { invertColor } from "../../common/util/appUtils";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";

export default function MilestonesNew({ dealName }) {
  const [milestoneObj, setMilestoneObj] = useState([]);
  const [expandedPipelines, setExpandedPipelines] = useState({});

  function calculateMilestoneStatusDate(data, result) {
    let pipelineStatus = "";
    let date = Date.now();
    let count = { 'Not Started': 0, 'Completed': 0, 'In Progress': 0 };
    let modifiedData = [...data];

    const taskRowIds = data.map(t => t.TaskROWID);
    const filteredTimeline = result.filter(item => taskRowIds.includes(item.TaskROWID) && item.TaskStatus?.type === "custom");

    function convertToLocalTime(utcTimeString) {
      return moment(utcTimeString).local();
    }
    let earliestDate = null;
    let latestDate = null;

    for (let i = 0; i < data.length; i++) {
      let task = data[i];
      let stateData = task?.TaskFlowObject?.Nodes?.find((k) => k.id == task.TaskStatus)?.data;
      if (!stateData || !stateData.state) {
        count['In Progress']++;
        const filteredTasks = result.filter(item => task.TaskROWID == item.TaskROWID && item.TaskStatus?.type == "custom");
        let latestdt = null;
        filteredTasks.forEach(item => {
          const localMoment = convertToLocalTime(item.UTCTimeString);
          if (!latestdt || localMoment.isAfter(latestdt)) latestdt = localMoment;
        })
        modifiedData[i]['statusDate'] = latestdt ? latestdt.format('MM/DD/YYYY') : moment().format('MM/DD/YYYY')
      } else if (stateData?.state == 'Start') {
        count['Not Started']++;
        modifiedData[i]['statusDate'] = moment(task.CREATEDTIME).format('MM/DD/YYYY');
      } else if (stateData?.state == 'Close') {
        count['Completed']++;
        const filteredTasks = result.filter(item => task.TaskROWID == item.TaskROWID && item.TaskStatus?.type == "custom");
        let latestdt = null;
        filteredTasks.forEach(item => {
          const localMoment = convertToLocalTime(item.UTCTimeString);
          if (!latestdt || localMoment.isAfter(latestdt)) latestdt = localMoment;
        })
        modifiedData[i]['statusDate'] = latestdt ? latestdt.format('MM/DD/YYYY') : moment().format('MM/DD/YYYY')
      }
      modifiedData[i]['statusColor'] = stateData?.color || 'lightgray';
      modifiedData[i]['statusLabel'] = stateData?.label || 'Unknown';
    }
    pipelineStatus = data.length == count['Completed'] ? 'Completed' : data.length === count['Not Started'] ? 'Not Started' : 'In Progress';

    if (filteredTimeline.length > 0) {
      filteredTimeline.forEach(item => {
        const localMoment = convertToLocalTime(item.UTCTimeString);
        if (!earliestDate || localMoment.isBefore(earliestDate)) earliestDate = localMoment;
        if (!latestDate || localMoment.isAfter(latestDate)) latestDate = localMoment;
      });
    } else {
      for (let task of data) {
        if (task.CREATEDTIME) {
          const localMoment = moment(task.CREATEDTIME).local();
          if (!earliestDate || localMoment.isBefore(earliestDate)) {
            earliestDate = localMoment;
          }
          if (!latestDate || localMoment.isAfter(latestDate)) {
            latestDate = localMoment;
          }
        }
      }
      latestDate = earliestDate;
    }

    if (pipelineStatus == 'Not Started') {
      date = earliestDate ? earliestDate.format('MM/DD/YYYY') : moment().format('MM/DD/YYYY');
    } else {
      date = latestDate ? latestDate.format('MM/DD/YYYY') : moment().format('MM/DD/YYYY');
    }

    return { Status: pipelineStatus, Date: date, Tasks: modifiedData };
  }

  const togglePipelineExpansion = (pipelineRowId) => {
    setExpandedPipelines((prevState) => ({
      ...prevState,
      [pipelineRowId]: !prevState[pipelineRowId]
    }));
  };

  function colorNameToHex(color) {
    const ctx = document.createElement("canvas").getContext("2d");
    ctx.fillStyle = color;
    return ctx.fillStyle;
  }

  useEffect(() => {
    if (dealName) {
      AwsServerService.getPipelineDataByDeal(dealName, "findMilestone").then((res) => {
        if (res.length > 0) {
          AwsServerService.getTimelinesForTasks(res.map(e => e.Tasks.map(r => r.TaskROWID)).flat()).then((result) => {
            const array = [];
            for (let i = 0; i < res.length; i++) {
              let obj = {};
              let tasks = res[i].Tasks;
              obj['PipelineName'] = res[i].PipelineName;
              obj['PipelineROWID'] = res[i].PipelineROWID;
              const { Status, Date, Tasks } = calculateMilestoneStatusDate(tasks, result.data);
              obj['Milestone Status'] = Status;
              obj['Milestone Date'] = Date;
              obj['Tasks'] = Tasks;
              array.push(obj);
            }
            setMilestoneObj(array);
          });
        } else {
          setMilestoneObj([]);
        }
      }).catch((err) => setMilestoneObj([]));
    }
  }, [dealName]);

  const colors = { 'In Progress': 'orange', 'Completed': 'lightgreen', 'Not Started': 'lightgray' };

  return (
  <div className="milestone-chart" style={{ height: '37rem', overflow: 'auto' }}>
    <table className="milestone-table">
      <thead>
        <tr className="milestone-chart-header">
          <th className="column">Milestone </th>
          <th className="column">Status </th>
          <th className="column">Status Date</th>
        </tr>
      </thead>
      <tbody className="milestone-chart-body">
        {milestoneObj.map((obj, i) => (
          <React.Fragment key={i}> 
            <tr className="milestone-row">
              <td className="column">
                <button
                  className="expand-collapse-btn"
                  onClick={() => togglePipelineExpansion(obj.PipelineROWID)}
                >
                  {expandedPipelines[obj.PipelineROWID] ? <FontAwesomeIcon icon={faCaretDown} /> : <FontAwesomeIcon icon={faCaretRight} />}
                </button>
                <div className={"Elipsis-Class"} title={`${obj.PipelineName}`}>{obj.PipelineName}</div>
              </td>
              <td className="column">
                <div className="statusDiv"
                  style={{ background: colors[obj['Milestone Status']], color: invertColor(colorNameToHex(colors[obj['Milestone Status']]), true) }}>
                  {obj['Milestone Status']}
                </div>
              </td>
              <td className="column">{obj['Milestone Date']}</td>
            </tr>
 
            {expandedPipelines[obj.PipelineROWID] && obj.Tasks.map((task, index) => (
              task.IsMilestone == 1 && (
                <tr className="milestone-row" key={index} style={{ background: '#f5f5f5' }}>
                  <td className="column Elipsis-Class" title={`${task.TaskName}`} style={{ paddingLeft: '30px', textIndent: '34px', 
                    textAlign: 'start'}}>
                    {task.TaskName}</td>
                  <td className="column">
                    <div title={`${task.statusLabel}`} className="statusDiv Elipsis-Class" style={{ paddingLeft: '6px', background: task.statusColor, color: invertColor(colorNameToHex(task.statusColor), true)
                    }}>
                      {task.statusLabel}
                    </div>
                  </td>
                  <td className="column">{task.statusDate}</td>
                </tr>
              )
            ))}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  </div>
);

}
